import React from 'react';
import styled from 'styled-components';

import { Center, Tooltip } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  score: number;
  tooltip?: string;
}

const colors = {
  85: '#69B34C',
  70: ' #ACB334',
  55: '#FFBC0F',
  40: '#FF8000',
  25: ' #FF4E11',
  0: '#F74040',
};

const MatchingScore: React.FC<React.PropsWithChildren<Props>> = ({
  score,
  tooltip,
}) => {
  const getColorForScore = (_score: number) => {
    const colorKeys = Object.keys(colors)
      .map((value) => parseInt(value))
      .reverse();
    let index = 0;
    while (colorKeys[index] && _score < colorKeys[index]) index++;
    return colors[colorKeys[index]];
  };

  const { t } = useTranslation();

  if (score === null) return null;

  return (
    <Tooltip
      label={
        tooltip ||
        t(
          'The matching score is based on the amount this insurance product covers your risk objects It takes into account your preferences and is comparable to other insurance products in your region This number should be used as a comparison metric between offers and not as an absolute value',
        )
      }
    >
      <Center cursor="pointer">
        <MatchingIconWrapper>
          {Object.values(colors)
            .reverse()
            .map((value) => (
              <ColorBlock key={`matching_color_${value}`} color={value} />
            ))}
        </MatchingIconWrapper>
        <Score color={getColorForScore(score)}>
          {Number(score).toFixed(2)} %
        </Score>
      </Center>
    </Tooltip>
  );
};

const Score = styled.p<{ color: string }>`
  font-size: 1.8rem;
  color: ${({ color }) => color};
  font-weight: 500;
  line-height: 125%;
  white-space: nowrap;
`;

const ColorBlock = styled.div<{ color: string }>`
  &:first-child {
    border-radius: 50% / 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:last-child {
    border-radius: 50% / 100%;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  background-color: ${({ color }) => color};
  width: 8px;
  height: 3px;

  margin-bottom: 1px;
`;

const MatchingIconWrapper = styled.div`
  margin-right: 0.8rem;
`;

export default MatchingScore;
